export default __webpack_public_path__ + "media/images/fonts/glyphicons-halflings-regular-fa2772327f55d8198301fdb8bcfc8158.woff";